export const present = ({latitude, longitude}={}) => (!!latitude && !!longitude);
